import React, { useState } from 'react';
import { Bell, Mail, MessageSquare } from 'lucide-react';
export function NotificationPreferences() {
  const [preferences, setPreferences] = useState({
    email: true,
    sms: false,
    push: true,
    marketing: false
  });
  const toggle = (key: keyof typeof preferences) => {
    setPreferences(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-2127">
      <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-2128">
        Notification Preferences
      </h3>

      <div className="space-y-6" data-id="element-2129">
        <div className="flex items-center justify-between" data-id="element-2130">
          <div className="flex items-center" data-id="element-2131">
            <Mail className="h-5 w-5 text-gray-400 mr-3" data-id="element-2132" />
            <div data-id="element-2133">
              <p className="text-sm font-medium text-gray-900" data-id="element-2134">
                Email Notifications
              </p>
              <p className="text-xs text-gray-500" data-id="element-2135">
                Get updates about your rent and account
              </p>
            </div>
          </div>
          <button onClick={() => toggle('email')} className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${preferences.email ? 'bg-blue-600' : 'bg-gray-200'}`} data-id="element-2136">
            <span className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${preferences.email ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-2137" />
          </button>
        </div>

        <div className="flex items-center justify-between" data-id="element-2138">
          <div className="flex items-center" data-id="element-2139">
            <MessageSquare className="h-5 w-5 text-gray-400 mr-3" data-id="element-2140" />
            <div data-id="element-2141">
              <p className="text-sm font-medium text-gray-900" data-id="element-2142">
                SMS Notifications
              </p>
              <p className="text-xs text-gray-500" data-id="element-2143">
                Receive urgent alerts via text message
              </p>
            </div>
          </div>
          <button onClick={() => toggle('sms')} className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${preferences.sms ? 'bg-blue-600' : 'bg-gray-200'}`} data-id="element-2144">
            <span className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${preferences.sms ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-2145" />
          </button>
        </div>

        <div className="flex items-center justify-between" data-id="element-2146">
          <div className="flex items-center" data-id="element-2147">
            <Bell className="h-5 w-5 text-gray-400 mr-3" data-id="element-2148" />
            <div data-id="element-2149">
              <p className="text-sm font-medium text-gray-900" data-id="element-2150">
                Push Notifications
              </p>
              <p className="text-xs text-gray-500" data-id="element-2151">
                Real-time alerts on your device
              </p>
            </div>
          </div>
          <button onClick={() => toggle('push')} className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${preferences.push ? 'bg-blue-600' : 'bg-gray-200'}`} data-id="element-2152">
            <span className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${preferences.push ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-2153" />
          </button>
        </div>
      </div>
    </div>;
}